import {
  CompanyMode
} from "../entities/company.js";
function canAccessKnowledgeBaseSync(options) {
  return options.companyMode === CompanyMode.RECRUITING && (options.isAgentsEnabled || options.isKnowledgeBaseEnabled);
}
export {
  canAccessKnowledgeBaseSync
};
//# sourceMappingURL=knowledgeBaseSyncAccess.js.map
